var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[(false)?_c('div',{staticStyle:{"height":"400px","background-color":"purple","color":"white"}},[_vm._v(" FOOTER ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }